import React, { useEffect, useMemo, useState } from 'react'
import _ from 'lodash'
import { Button } from 'antd'
import ContentHeader from './ContentHeader'
import { useHearAbout, useI18n } from 'contexts/AuthContext'
import CareSelectButton from 'components/CareSelectButton/index'
import { ScreenKey, UploadSelectionOptionType } from './util'
import { useMetadataOptions, useUpdateClient } from 'hooks/careHooks'
import { getHealthieUserId, getLocalLanguage } from 'utils/authLocalStorage'
import { uploadSelectionPromise } from 'apis/FitOnCareAPI'
import { setBrazeProfile } from 'utils/brazeInit'
import { logAmplitudeEvent, setAmplitudeOption } from 'utils/amplitudeInit'
import CareInput from 'components/CareInput/index'
import { isMobile } from 'utils/basic'

const HearAbout = (props) => {
  const { i18n } = useI18n()
  const { hearAbout, setHearAbout } = useHearAbout()
  const [dataList, setDataList] = useState([])
  const { hearAboutOptions } = useMetadataOptions()
  const { updateClient } = useUpdateClient()

  useEffect(() => {
    logAmplitudeEvent('Screen View: Onboarding - Referrer', {
      language: getLocalLanguage(),
      sku: props.sku,
    })
  }, [props.sku])

  useEffect(() => {
    if (!_.isEmpty(hearAboutOptions) && _.isEmpty(dataList)) {
      const otherOption = _.remove(hearAboutOptions, (option) => {
        return option.name === 'Other'
      })
      setDataList(_.shuffle(hearAboutOptions).concat(otherOption))
    }
  }, [dataList, hearAboutOptions])

  const getUpdateClientSource = (clientSource, otherText) => {
    if (clientSource === 'ZocDoc') {
      return { ref_type: 'ad', ref_source: 'ZocDoc' }
    } else if (clientSource === 'Advertisement') {
      return { ref_type: 'ad', ref_source: 'Other' }
    } else {
      return {
        ref_type: 'other',
        ref_source: clientSource === 'Other' ? otherText : clientSource,
      }
    }
  }

  const onNext = () => {
    switch (props.sku) {
      case 'pt':
        props.setCurrentKey(ScreenKey.PAIN_LOCATED)
        break
      case 'msk':
        props.setCurrentKey(ScreenKey.TALK_ABOUT_COVERAGE)
        break
      case 'wlc':
        props.setCurrentKey(ScreenKey.PAST_DIAGNOSIS)
        break
      default:
        props.setCurrentKey(ScreenKey.TALK_ABOUT_COVERAGE)
    }
  }

  const updateClientInfo = (item) => {
    uploadSelectionPromise({
      optionType: UploadSelectionOptionType.HEAR_ABOUT_OPTION,
      selectedOptionId: item.id,
      otherInputText: item.otherText,
    })
    updateClient({
      variables: {
        id: getHealthieUserId(),
        client_source: getUpdateClientSource(item.name, item.otherText),
      },
      onSuccess: () => {
        onNext()
      },
    })
    setBrazeProfile({ userAttribution: item.name })
    logAmplitudeEvent('Click: Onboarding - Referrer', {
      Referrer: item.name,
      language: getLocalLanguage(),
      sku: props.sku,
    })
    setAmplitudeOption('Referrer', item.name)
  }

  const isNextButtonEnable = useMemo(() => {
    return (
      !_.isEmpty(hearAbout) &&
      (hearAbout.name !== 'Other' || !_.isEmpty(hearAbout.otherText))
    )
  }, [hearAbout])

  return (
    <div className='info-sec'>
      <ContentHeader {...props} />
      <div className='info-content'>
        <div className='title'>
          {i18n('How did you hear about FitOn Care?')}
        </div>
        <div className='two-grid-sec'>
          {dataList.map((item, index) => (
            <CareSelectButton
              key={index}
              {...{
                selected: hearAbout.id === item.id,
                setSelected: () => {
                  setHearAbout({ ...item })
                },
                text: item.name,
                className: 'left-align',
              }}
            />
          ))}
          {hearAbout.name === 'Other' && (
            <CareInput
              {...{
                inputValue: hearAbout.otherText || '',
                setInputValue: (value) => {
                  const regex = /^[a-zA-Z0-9\s]*$/
                  if (regex.test(value)) {
                    setHearAbout({ ...hearAbout, otherText: value })
                  }
                },
                placeholder: i18n('Please specify'),
                focus: hearAbout.name === 'Other',
                maxLength: 50,
                className: 'input-sec-padding',
              }}
            />
          )}
        </div>
        <Button
          className='btn-primary full-width-btn'
          style={isMobile() ? { width: '100%' } : {}}
          onClick={() => {
            updateClientInfo({ ...hearAbout })
          }}
          disabled={!isNextButtonEnable}
        >
          {i18n('Next')}
        </Button>
      </div>
    </div>
  )
}

export default HearAbout
